<template>
    <el-dialog
        title="选择试题"
        :visible.sync="visible"
        width="11rem"
        class="step-audit-dialog"
        key="exam3Dialog"
        :before-close="handleDialogClose">
        <el-form :model="form" :inline="true" label-width="100px" key="3" class="user-step-search-form">
            <el-form-item label="试题标题：" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="所属目录：" prop="paperGroupId">
                <el-cascader
                    :options="regions"
                    :props="{ checkStrictly: true, label: 'name', value: 'id', children: 'childrenList' }"
                    v-model="form.paperGroupId"
                    clearable></el-cascader>
            </el-form-item>
            <el-form-item label="" class="search-itrm-btn">
                <el-button size="mini" @click="handleDialogSearch">查询</el-button>
                <el-button size="mini" class="reset-btn" @click="handleDialogReset">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="training-step-table">
            <el-table :data="tableForm.formResult.list" style="width: 100%" key="exam3table" @selection-change="handleSelectionChange">
                <el-table-column key="exam3col9" type="selection" width="55"></el-table-column>
                <el-table-column key="exam3col1" type="index" label="序号"></el-table-column>
                <el-table-column key="exam3col2" prop="title" show-overflow-tooltip label="试题标题" width="168"></el-table-column>
                <el-table-column key="exam3col3" prop="orgName" label="发布单位"></el-table-column>
                <el-table-column key="exam3col4" prop="paperGroupName" label="所属目录"></el-table-column>
                <el-table-column key="exam3col5" prop="type" label="题型">
                    <template slot-scope="scope">
                        <span>{{typeObj[scope.row.type]}}</span>
                    </template>
                </el-table-column>
                <el-table-column key="exam3col6" prop="isPublish" label="状态">
                    <template slot-scope="scope">
                        <span>已发布</span>
                    </template>
                </el-table-column>
                <el-table-column key="exam3col7" prop="createTime" label="发布时间" width="168"></el-table-column>
                <el-table-column key="exam3col8" prop="creatorAccountNo" label="发布人账号"></el-table-column>
            </el-table>
            <pagination key="exam3page" @request-form-list="queryPaperList" :form="tableForm"></pagination>
        </div>
        <div class="dialog-footer">
            <el-button type="primary" size="mini" @click="handleDialogClose">取消</el-button>
            <el-button type="primary" size="mini" @click="handleDialogConfirm">确认</el-button>
        </div>
    </el-dialog>
</template>
<script>
import pagination from '@/components/pagination/index'
export default {
    name: 'subjectListDailog',
    props: ['visible'],
    components: { pagination },
    data() {
        return {
            regions: [],
            form: {title: '', paperGroupId:'' },
            tableForm: {
                formResult: { currentPage: 1, list: [], total: 0 },
                pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
            },
            typeObj: { 0: '单选',1: '多选',2: '问答',3: '填空',4: '评分',5: '判断' },
            selectedData: []
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit('closeDailog')
        },
        handleDialogConfirm() {
            this.$emit('confirmDailog', this.selectedData)
        },
        handleDialogSearch() {
            this.tableForm.pageData.currentPage = 1
            this.queryPaperList()
        },
        handleDialogReset() {
            this.form.title = ''
            this.form.paperGroupId = []
            this.handleDialogSearch()
        },
        // 加载条件树
        trainExamTreeList() {
            this.$api.user.exam.trainExamTreeList().then(res => {
                this.regions = res.data
            })
        },
         // 加载列表
        queryPaperList() {
            this.$api.user.exam.subjectListPage({
                formData: { title: this.form.title, isPublish: 1, paperGroupId: this.form.paperGroupId.length > 0 ? this.form.paperGroupId[0] : ''},
                pageData: this.tableForm.pageData
            }).then(res => {
                this.tableForm.formResult = res.data
            })
        },
        handleSelectionChange(data) {
            this.selectedData = data
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.trainExamTreeList()
                this.handleDialogReset()
                this.selectedData = []
            }
        }
    }
}
</script>